import { type PropsWithChildren } from "react";

import { RiskWarningCard } from "@vega-core/components/Cards/RiskWarningCard/RiskWarningCard";
import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { useDeviceWidth } from "@vega-core/hooks/useDeviceWidth";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

export function Container({
  children,
  className,
  withInfoCard,
}: PropsWithChildren<{
  className?: string;
  withInfoCard?: boolean;
}>) {
  const { theme } = useTheme();
  const isMobileOnly = !useDeviceWidth("sm");

  return (
    <>
      {isTruthy(withInfoCard) && isMobileOnly ? (
        <RiskWarningCard isContainer={isMobileOnly} />
      ) : null}

      <div
        className={cnTwMerge(
          "flex min-h-dvh overflow-hidden w-full flex-col bg-background/primary px-4 text-text/primary md:px-0",
          theme,
          className,
        )}
        data-testid="mainContainer"
      >
        {children}
      </div>
    </>
  );
}
